module.exports = __webpack_public_path__ + "static/media/putri_sofia.476a78b1.png";